@if (!loading) {
  <app-public-page-template [cardSize]="CARDSIZE.XL" [headerText]="'Register new user'">
    <form (ngSubmit)="onSubmit()" [formGroup]="form">
      <div class="row">
        <div class="form-group col-md-6">
          <label for="name"><h3>Name:</h3></label> <input [ngClass]="{ 'is-invalid': displayError(f.name)}"
          autocomplete="given-name"
          class="form-control"
          formControlName="name"
          id="name"
          placeholder="Name"
          type="text"/>
        @if (displayError(f.name)) {
          <div class="invalid-feedback">
            @if (f.name.errors.required) {
              <div>Name is required</div>
            }
          </div>
        }
      </div>
      <div class="form-group col-md-6">
        <label for="surname"><h3>Surname:</h3></label>
        <input [ngClass]="{ 'is-invalid': displayError(f.surname) }"
          autocomplete="family-name"
          class="form-control"
          formControlName="surname"
          id="surname"
          placeholder="Surname"
          type="text"/>
        @if (displayError(f.surname)) {
          <div class="invalid-feedback">
            @if (f.surname.errors.required) {
              <div>Surname is required</div>
            }
          </div>
        }
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-6">
        <label for="email"><h3>Email:</h3></label>
        <input [ngClass]="{ 'is-invalid': displayError(f.email) }"
          autocomplete="email"
          class="form-control"
          formControlName="email"
          id="email"
          placeholder="Email"
          type="text"/>
        @if (displayError(f.email)) {
          <div class="invalid-feedback">
            @if (f.email.errors.required) {
              <div>Email address is required</div>
            }
            @if (f.email.errors.email) {
              <div>Invalid email address</div>
            }
            @if (f.email.errors.duplicateEmail) {
              <div>A user with this email address already exists.
              </div>
            }
          </div>
        }
      </div>
      <div class="form-group col-md-6">
        <validation [formGroup]="form" controlName="mobileNumber" displayName="Mobile number">
          <label for="mobile-number"><h3>Mobile Number:</h3></label>
          <input [ngClass]="{ 'is-invalid': displayError(f.mobileNumber) }"
            autocomplete="tel"
            class="form-control"
            formControlName="mobileNumber"
            id="mobile-number"
            placeholder="0831234567 or +27831234567"
            type="tel"/>
        </validation>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-6">
        <label for="password"><h3>Password:</h3></label>
        <input [ngClass]="{ 'is-invalid': displayError(f.password) }"
          autocomplete="new-password"
          class="form-control"
          formControlName="password"
          id="password"
          placeholder="Password"
          type="password"/>
        @if (displayError(f.password)) {
          <div class="invalid-feedback">
            @if (f.password.errors.required) {
              <div>Password is required</div>
            }
            @if (f.password.errors.invalidPassword) {
              <div>{{ f.password.errors.invalidPassword }}</div>
            }
          </div>
        }
      </div>
      <div class="form-group col-md-6">
        <label for="password-confirm"><h3>Confirm Password:</h3></label>
        <input [ngClass]="{ 'is-invalid': displayError(f.confirmPassword)}"
          autocomplete="new-password"
          class="form-control"
          formControlName="confirmPassword"
          id="password-confirm"
          placeholder="Confirm Password"
          type="password"/>
        @if (displayError(f.confirmPassword)) {
          <div class="invalid-feedback">
            @if (f.confirmPassword.errors.required) {
              <div>Please confirm your password
              </div>
            }
            @if (f.confirmPassword.errors.passwordMismatch) {
              <div>Password does not match
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="row action-button-group">
      <button [disabled]="loading" class="navy-btn center">
        Save <i [hidden]="!loading" class="fa fa-spinner fa-spin" style="font-size:15px"></i>
      </button>
    </div>
  </form>
</app-public-page-template>
}
@if (loading) {
  <app-public-page-template [headerText]="'Loading...'"></app-public-page-template>
}
